import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';

export const ReportRecommendationCont = styled.div`
  ${({theme}: IThemeProvider) => `
    margin: ${theme.layout.spacing.decy} 0 0 0;
  `}
`;

export const RecommendationCont = styled.div`
  display: flex;
`;